module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-15.43012741.mp3";